// eslint-disable-next-line no-empty-function
// export function updateFunctionFromState() {
//   const { key, value, code } = this.state
//   try {
//     const res = this.call('updateFunction')
//     this.test('Updating Function in data', () => {
//       return this.testCase(
//         'Value equals canvas context',
//         'isEqualFunction',
//         this.getFunctions(key),
//         value
//       )
//     })

//     if (res?.success) {
//       this.call('updateFunctionOnCanvas', code)
//       this.test('Updating Function on Canvas', () => {
//         return (
//           this.testCase(
//             'Value equals root state',
//             'isEqualFunction',
//             this.getFunctions(key),
//             value
//           ) &&
//           this.testCase(
//             'Value equals root state',
//             'isEqual',
//             this.getCanvasCollection()
//               .context.functions[key].toString()
//               .replaceAll('\n', ''),
//             value.toString().replaceAll('\n', '')
//           )
//         )
//       })
//     }
//   } catch (e) {
//     console.error(e)
//   }
// }

// export function updateFunctionOnCanvas(codeStr, type = 'functions') {
//   // window.requestAnimationFrame(() => {
//   const Canvas = this.getCanvas()
//   const { chosen } = this.getCanvasScope()
//   const Collection = this.getCanvasCollection()
//   const { key } = this.state
//   if (Collection) {
//     const { contentWindow } = Canvas.Iframe.node
//     const evalCode = this.call('evalStringCodeUnsafe', codeStr, {
//       secrets: this.getSecrets(),
//       window: contentWindow
//     })
//     const ctx = Collection.context
//     ctx[type][key] = evalCode
//     ctx.utils[key] = evalCode
//     const { packages } = contentWindow
//     packages[type][key] = evalCode
//     packages.utils[key] = evalCode
//   } else {
//     this.error('Canvas Collection was not found')
//   }

//   if (chosen) {
//     const ChosenScene = this.getChosenScene()
//     const { ComponentFrameCanvas } = ChosenScene.ViewSvitcher
//     const ChosenFrame = ComponentFrameCanvas?.Iframe
//     if (!ChosenFrame) {
//       return
//     }
//     const { contentWindow } = ChosenFrame.node
//     const evalCode = this.call('evalStringCodeUnsafe', codeStr, {
//       secrets: this.getSecrets(),
//       window: contentWindow
//     })
//     const { packages } = contentWindow
//     packages[type][key] = evalCode
//     packages.utils[key] = evalCode
//     ChosenFrame.update()
//   }
//   // })
// }

// export function updateFunction() {
//   const { key } = this.state
//   try {
//     return this.sdk.updateItem(
//       this.call('getType'),
//       {
//         ...this.state,
//         key
//       },
//       { message: `Updating function ${key}` }
//     )
//   } catch (err) {
//     this.state.update({
//       err
//     })
//   }
// }

// export async function duplicateFunction() {
//   const { key } = this.state
//   const type = this.call('getType')

//   this.sdk.addItem(
//     type,
//     {
//       ...this.state,
//       key: key.concat('Copy')
//     },
//     {
//       message: `Duplicating function ${key}`,
//       ...this.call('returnAddedCanvasPageChanges', type, key)
//     }
//   )

//   const updatedSection = await this.call('rerenderFileSidebarByType', type)
//   if (!updatedSection) {
//     await this.getDynamicIsland()?.update()
//   }
// }
